import React from "react";
import "./Services.css";

import treatmentAnkle from '../Images/treatment-ankle.jpg';
import treatmentTaping from '../Images/treatment-taping.jpg';
import treatmentEstim from '../Images/treatment-estim.jpg';
import treatmentGait from '../Images/treatment-gait.jpg';
import treatmentCupping from '../Images/treatment-cupping.jpg';
import treatmentSled from '../Images/treatment-sled.jpg';

const serviceGroups = [
  {
    title: "Injury Rehabilitation",
    image: treatmentAnkle,
    imageAlt: "Blaine guiding a resisted ankle exercise during rehab",
    items: [
      "Post-surgical rehab (knee, shoulder, hip, spine, etc.)",
      "Sports injury recovery (sprains, strains, tendonitis, fractures)",
      "Return-to-sport programs",
      "Chronic pain management",
    ],
  },
  {
    title: "Orthopedic Care",
    image: treatmentEstim,
    imageAlt: "Electrical stimulation therapy applied to the lower back",
    items: [
      "Joint pain treatment (shoulder, knee, hip, ankle, wrist)",
      "Arthritis management",
      "Back and neck pain relief",
      "Pre- and post-operative therapy",
    ],
  },
  {
    title: "Sports-Specific Rehabilitation",
    image: treatmentTaping,
    imageAlt: "Blaine taping a young athlete's wrist",
    items: [
      "ACL reconstruction rehab",
      "Rotator cuff repair rehab",
      "Concussion management & return-to-play",
      "Throwing & overhead athlete rehab",
    ],
  },
  {
    title: "Specialized Treatments",
    image: treatmentCupping,
    imageAlt: "Cupping therapy session",
    items: [
      "Dry needling",
      "Cupping",
      "Manual therapy & joint mobilization",
      "Soft tissue mobilization & myofascial release",
      "Blood flow restriction training",
      "Balance & proprioception training",
      "Vertigo and vestibular rehab",
      "Temporomandibular joint dysfunction",
    ],
  },
  {
    title: "Performance & Movement Restoration",
    image: treatmentGait,
    imageAlt: "Blaine coaching a client through a gait and movement assessment",
    items: [
      "Strength & conditioning integration into rehab",
      "Speed, agility, and power restoration post-injury",
      "Sport-specific movement retraining",
      "Functional mobility programs",
    ],
  },
  {
    title: "Preventative & Maintenance Care",
    image: treatmentSled,
    imageAlt: "A client pushing a weighted sled for functional strength training",
    items: [
      "Injury prevention screenings",
      "Biomechanical and movement assessments",
      "Pre-season athletic readiness programs",
      "Workplace injury prevention",
    ],
  },
];

export default function Services() {
  return (
    <main className="Services">
      <p className="section-eyebrow">What We Offer</p>
      <h1 className="servicesTitle">Physical Therapy Services</h1>
      <hr />
      <div className="list">
        {serviceGroups.map((group) => (
          <div className="card s" key={group.title}>
            {group.image && (
              <div className="s-image">
                <img src={group.image} alt={group.imageAlt} loading="lazy" />
              </div>
            )}
            <h2 className="subtitle">{group.title}</h2>
            <ul>
              {group.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </main>
  );
}
